import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { TableSortOption } from '@evinced-private/ui-common';

import { getAllIssues } from 'src/apps/dashboard/services/mobileDashboardService';
import { IMobileAllIssuesResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { ISSUES_CACHE_TIME, ISSUES_STALE_TIME } from 'src/common/consts/QueryConfigs';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_MOBILE_ALL_ISSUES } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileAllIssuesData = (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption,
	enabled = true
): UseQueryResult<IMobileAllIssuesResult> => {
	return useQuery(
		[DASHBOARD_MOBILE_ALL_ISSUES, filters, page, sizePerPage, sort],
		async (): Promise<IMobileAllIssuesResult> =>
			getAllIssues({
				filters,
				page,
				sizePerPage,
				sort
			}),
		{
			enabled,
			keepPreviousData: true,
			staleTime: ISSUES_STALE_TIME,
			cacheTime: ISSUES_CACHE_TIME,
			refetchOnWindowFocus: false
		}
	);
};
